export default "__VITE_ASSET__ee40aa8a__"